import { createFileRoute } from "@tanstack/react-router";
import Sell from "@/pages/Sell";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/sell/")({
  head: () => routeHead("/sell/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Sell />
  );
}
